export const translationNavigation_da_part3 = {
  profilePicture: "Profilbillede",
  currentProfilePicture: "Nuværende profilbillede",
  profilePictureDescription: "Dette vil blive vist ved siden af dine beskeder i chatten",
  uploadNewProfilePicture: "Upload nyt profilbillede",
  chooseFile: "Vælg fil",
  uploading: "Uploader...",
  supportedFormats: "Understøttede formater: JPEG, PNG, GIF, WebP. Maks størrelse: 5MB",
  saving: "Gemmer...",
  profilePictureUpdatedSuccess: "Profilbillede opdateret med succes!",
  errorUploadingProfilePicture: "Fejl ved upload af profilbillede. Prøv igen.",
  invalidFileType: "Vælg venligst en gyldig billedfil (JPEG, PNG, GIF eller WebP)",
  fileSizeError: "Filstørrelsen skal være mindre end 5MB",
  notificationSettings: "Notifikationsindstillinger",
  emailNotificationsLabel: "Emailnotifikationer",
  emailWhenTagged: "Send mig en email, når jeg tagges i en rapport",
  livechatNotificationsLabel: "Livechat-notifikationer",
  livechatPopupSetting: "Vis en pop-up, når der er ny aktivitet i live chat",
  livechatOtherAgentsSetting: "Giv mig besked om chats, som andre agenter håndterer",
  notificationSoundTitle: "Notifikationslyd",
  notificationSoundDescription: "Afspil en lyd når du modtager nye livechat beskeder",
  testNotificationSound: "Test lyd",
  testSoundEnabled: "Klik for at teste notifikationslyden",
  testSoundDisabled: "Aktivér lydnotifikationer for at teste",
  userProfilePicturesTitle: "Bruger Profilbilleder",
  showUserProfilePicturesTitle: "Vis Bruger Profilbilleder",
  showUserProfilePicturesDescription:
    "Vis dyre avatar profilbilleder for brugere i livechat samtaler for at hjælpe med at identificere og huske brugere",

  // User edit / Løsninger chatbot editor — tab bar (short labels avoid overflow)

  // User edit / Løsninger chatbot editor — tab bar (short labels avoid overflow)
  userEditTabPreview: "Forhåndsvisning",
  userEditTabBasic: "Grundindstillinger",
  userEditTabProducts: "Produkter",
  userEditTabExtra: "Ekstra indstillinger",
  userEditTabMain: "Hovedflow",
  userEditTabRouting: "Fordelingsflow",
  userEditTabStatistics: "Statistikflow",
  userEditTabSuggestion: "Forslagsflow",
  userEditTabApivar: "API-var flow",
  userEditTabMetaPrefix: "Meta: ",
  userEditTabDomainRestrictions: "Domænebegrænsninger",
  userEditTabImage: "Billedeflow",
  userEditTabShopify: "Shopify",
  userEditTabMagento: "Magento",
  userEditTabShipmondo: "Shipmondo",
  userEditTabCommerceTools: "CommerceTools",
  userEditTabUniversalApiPlanner: "Universal API planner",
  userEditTabUniversalApi: "Universal API",
  userEditUniversalApiPlannerStepLimitsTitle: "Planner-trin (min / max)",
  userEditUniversalApiPlannerStepLimitsHint:
    'Minimum: hvor mange planlægningsrunder der kræves før "finish". Maksimum: højste antal planner-kald pr. besked (1–10). Gem ændringer separat.',
  userEditUniversalApiPlannerMinSteps: "Minimumstrin",
  userEditUniversalApiPlannerMaxSteps: "Maksimumstrin",
  userEditUniversalApiPlannerSaveStepLimits: "Gem planner-grænser",
  userEditUniversalApiPlannerSavingStepLimits: "Gemmer…",

  userEditBasicSettingsSectionTitle: "Grundindstillinger",
  userEditNoKnowledgeBaseIndexesHint:
    "Ingen vidensbase-indekser konfigureret. Tilføj dem under Grundindstillinger.",
};
